(function () {
  const STOREFRONT_ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  const CART_PATH = window.routes && window.routes.cart_url ? window.routes.cart_url : STOREFRONT_ROOT + 'cart';
  const FREE_SHIPPING_CENTS_USD = 6000;
  const COPY = {
    en: {
      title: 'Quick Basket',
      eyebrow: 'Order counter · 購物小票',
      shippingDefault: 'Free worldwide shipping on orders of US$60 or more',
      shippingUnlocked: 'Free worldwide shipping unlocked',
      shippingRemaining: function (amount) { return 'US$' + amount + ' away from free worldwide shipping'; },
      review: 'Review your basket',
      reviewAria: 'Review your basket on the full cart page',
      continueShopping: 'Continue shopping',
      reassurance: 'Secure checkout · Worldwide delivery support'
    },
    'zh-tw': {
      title: '快速購物籃',
      eyebrow: '訂單櫃台 · 購物小票',
      shippingDefault: '訂單滿 US$60 全球免運費',
      shippingUnlocked: '已享全球免運費',
      shippingRemaining: function (amount) { return '再消費 US$' + amount + ' 即享全球免運費'; },
      review: '查看完整購物車',
      reviewAria: '前往完整購物車頁面',
      continueShopping: '繼續購物',
      reassurance: '安全結帳 · 全球配送支援'
    },
    ja: {
      title: 'クイックカート',
      eyebrow: 'ご注文カウンター',
      shippingDefault: 'US$60以上のご注文で世界送料無料',
      shippingUnlocked: '世界送料無料が適用されました',
      shippingRemaining: function (amount) { return '世界送料無料まであとUS$' + amount; },
      review: 'カートを確認',
      reviewAria: 'カートページで内容を確認',
      continueShopping: '買い物を続ける',
      reassurance: '安全な決済 · 世界各国への配送をサポート'
    },
    ko: {
      title: '빠른 장바구니',
      eyebrow: '주문 카운터',
      shippingDefault: 'US$60 이상 주문 시 전 세계 무료 배송',
      shippingUnlocked: '전 세계 무료 배송이 적용되었습니다',
      shippingRemaining: function (amount) { return '전 세계 무료 배송까지 US$' + amount + ' 남았습니다'; },
      review: '장바구니 확인',
      reviewAria: '전체 장바구니 페이지에서 확인',
      continueShopping: '쇼핑 계속하기',
      reassurance: '안전한 결제 · 전 세계 배송 지원'
    }
  };
  let progressRequest = null;
  let observerTimer = null;

  function getCopy() {
    const locale = (document.documentElement.lang || 'en').toLowerCase();
    if (locale.indexOf('zh') === 0) return COPY['zh-tw'];
    if (locale.indexOf('ja') === 0) return COPY.ja;
    if (locale.indexOf('ko') === 0) return COPY.ko;
    return COPY.en;
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function makeShippingPanel() {
    const copy = getCopy();
    const panel = document.createElement('div');
    panel.className = 'mc-quick-basket-shipping';
    panel.innerHTML =
      '<div class="mc-quick-basket-shipping__copy"><span class="mc-quick-basket-shipping__text">' + copy.shippingDefault + '</span></div>' +
      '<div class="mc-quick-basket-shipping__track" aria-hidden="true"><span class="mc-quick-basket-shipping__bar"></span></div>';
    return panel;
  }

  function refreshProgress(drawer) {
    if (progressRequest) return progressRequest;
    const localeCopy = getCopy();

    progressRequest = fetch(CART_PATH + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        const panel = drawer.querySelector('.mc-quick-basket-shipping');
        const copy = panel && panel.querySelector('.mc-quick-basket-shipping__text');
        if (!panel || !copy) return;
        const track = panel.querySelector('.mc-quick-basket-shipping__track');
        if (track) track.hidden = cart.currency !== 'USD';

        if (cart.currency === 'USD') {
          const remaining = Math.max(FREE_SHIPPING_CENTS_USD - cart.total_price, 0);
          const progress = Math.min((cart.total_price / FREE_SHIPPING_CENTS_USD) * 100, 100);
          panel.style.setProperty('--mc-shipping-progress', progress + '%');
          copy.textContent = remaining === 0
            ? localeCopy.shippingUnlocked
            : localeCopy.shippingRemaining((remaining / 100).toFixed(2));
        } else {
          panel.style.setProperty('--mc-shipping-progress', '0%');
          copy.textContent = localeCopy.shippingDefault;
        }
      })
      .catch(function () {
        /* The reassurance text remains useful if the cart request is unavailable. */
      })
      .finally(function () {
        progressRequest = null;
      });

    return progressRequest;
  }

  function enhanceDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    const copy = getCopy();

    const header = drawer.querySelector('.drawer__header');
    const heading = drawer.querySelector('.drawer__heading');
    if (header && heading) {
      if (heading.textContent.trim() !== copy.title) heading.textContent = copy.title;
      if (!header.querySelector('.mc-quick-basket-eyebrow')) {
        const eyebrow = document.createElement('p');
        eyebrow.className = 'mc-quick-basket-eyebrow';
        eyebrow.textContent = copy.eyebrow;
        header.insertBefore(eyebrow, heading);
      }

      if (!drawer.querySelector('.mc-quick-basket-shipping')) {
        header.insertAdjacentElement('afterend', makeShippingPanel());
      }
    }

    const checkoutButton = drawer.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) {
      checkoutButton.type = 'button';
      checkoutButton.removeAttribute('name');
      checkoutButton.removeAttribute('form');
      if (checkoutButton.textContent.trim() !== copy.review) {
        checkoutButton.textContent = copy.review;
      }
      checkoutButton.setAttribute('aria-label', copy.reviewAria);
      checkoutButton.dataset.mcBasketReview = 'true';
    }

    const ctas = drawer.querySelector('.cart__ctas');
    if (ctas && !drawer.querySelector('.mc-quick-basket-continue')) {
      const continueLink = document.createElement('a');
      continueLink.href = '#';
      continueLink.className = 'mc-quick-basket-continue';
      continueLink.textContent = copy.continueShopping;
      continueLink.addEventListener('click', function (event) {
        event.preventDefault();
        drawer.close();
      });
      ctas.insertAdjacentElement('afterend', continueLink);
    }

    const footer = drawer.querySelector('.drawer__footer');
    if (footer && !drawer.querySelector('.mc-quick-basket-reassurance')) {
      const reassurance = document.createElement('p');
      reassurance.className = 'mc-quick-basket-reassurance';
      reassurance.textContent = copy.reassurance;
      footer.appendChild(reassurance);
    }

    refreshProgress(drawer);
  }

  function isHeaderCartTrigger(element) {
    return element && element.closest && element.closest('#cart-icon-bubble, a.header__icon--cart');
  }

  function getQuickAddVariantId(form) {
    const input = form.querySelector('[name="id"]');
    if (input && input.value) return input.value;

    const productLink = form.parentElement && form.parentElement.querySelector('a[href*="variant="]');
    if (!productLink) return '';

    try {
      return new URL(productLink.href, window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  }

  async function submitQuickAdd(event) {
    const form = event.target && event.target.closest && event.target.closest('form.mc-quick-form');
    if (!form) return;

    const drawer = getDrawer();
    const variantId = getQuickAddVariantId(form);
    if (!drawer || typeof drawer.renderContents !== 'function' || !variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', formData.get('quantity') || '1');

    if (typeof drawer.getSectionsToRender === 'function') {
      formData.set('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }));
      formData.set('sections_url', window.location.pathname);
    }

    const action = (form.getAttribute('action') || STOREFRONT_ROOT + 'cart/add').replace(/\.js$/, '') + '.js';

    try {
      const response = await fetch(action, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item.');
      drawer.renderContents(result);
      window.setTimeout(enhanceDrawer, 40);
    } catch (error) {
      console.error('MolalaCook quick add:', error);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  document.addEventListener('submit', submitQuickAdd, true);

  document.addEventListener(
    'click',
    function (event) {
      const quickAddButton = event.target.closest && event.target.closest('form.mc-quick-form [type="submit"]');
      if (quickAddButton) {
        submitQuickAdd(event);
        return;
      }

      const reviewButton = event.target.closest && event.target.closest('[data-mc-basket-review="true"]');
      if (reviewButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(CART_PATH);
        return;
      }

      const cartTrigger = isHeaderCartTrigger(event.target);
      const drawer = getDrawer();
      if (!cartTrigger || !drawer) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      enhanceDrawer();
      drawer.open(cartTrigger);
    },
    true
  );

  function scheduleEnhancement() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(enhanceDrawer, 30);
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceDrawer();
    const drawer = getDrawer();
    if (!drawer) return;
    new MutationObserver(scheduleEnhancement).observe(drawer, { childList: true, subtree: true });
  });
})();
